import React, { ReactElement } from 'react';
import EmbeddedDealerCodeChange, { Dealer } from './EmbeddedDealerCodeChange';
import './dealer-selection-page.scss';
import { Shimmer } from '@mo/shimmer';

interface SelectedDealerDescriptionProps {
    dealerCode?: string;
    dealers?: Dealer[];
}

function SelectedDealerDescription(props: SelectedDealerDescriptionProps): ReactElement | null {
    const selectedDealer = props.dealers?.find(dealer => dealer.code === props.dealerCode);

    return selectedDealer
        ?
        <p id={'dealer-change-description'} className={'dealer-change-description'}>You are currently logged in as <br/>
            <b>{`${selectedDealer.name} - ${selectedDealer.code}, ${selectedDealer.address.postcode}`}</b>
        </p>
        : null
}


export interface DealerSelectionPageProps {
    baseUrl: string;
    redirectUrl: string;
    displayDealerChange: boolean;
    dealerCode?: string;
    dealers?: Dealer[];
    error?: boolean;
    loading: boolean;
}

function DealerSelectionPage(props: DealerSelectionPageProps): ReactElement {
    const dealerChange =
        <Shimmer loading={props.loading}>
            <h1 className='dealer-selection-page__title'>Please select a dealer code</h1>
            <SelectedDealerDescription dealerCode={props.dealerCode} dealers={props.dealers}/>
            <div className='dealer-selection-page__dealerCodeChange__container' >
            <EmbeddedDealerCodeChange baseUrl={props.baseUrl}
                                      onSuccessfulSubmission={() => {
                                          window.location.replace(props.redirectUrl)
                                      }}
                                      loading={props.loading}
                                      dealers={props.dealers}
                                      error={props.error}
                                      role={'card'}
            />
            </div>
        </Shimmer>;

    const pleaseLogin =
        <div>
            <h1 className='dealer-selection-page__title'>Please select a dealer code</h1>
            <p aria-label={'You can select a dealer code by navigating to the “User details” button'}>
                You can select a dealer code under the profile icon in the top right of the screen
            </p>
        </div>;

    return (
        <div className='dealer-selection-page__content'>
            {props.displayDealerChange ? dealerChange : pleaseLogin}
        </div>
    )
}

export default DealerSelectionPage;
